(() => {
  angular
    .module('gm.common.directives')
    .directive('gmAutoFocus', gmAutoFocusDirective);

  /**
   * Apply "focus" to the element.
   *
   * @param  {Object} $timeout
   */
  function gmAutoFocusDirective(
    $timeout
  ) {
    'ngInject';

    return {
      restrict: 'A',

      link(_scope, element, attrs) {
        $timeout(() => element[0].focus(), 50);

        attrs.$observe('gmAutoFocus', (isActive) => {
          if (isActive) {
            element[0].focus();
          } else {
            element[0].blur();
          }
        });
      }
    };
  }
})();
